import React from "react";

export default function MSAccess_Replace() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Replace</h1>
      <p>This is the MSAccess_Replace component generated from the SQL JSON.</p>
    </div>
  );
}
